<template>
  <div class="appbar font">
    <v-app-bar
      height="78"
      elevation="0"
      clipped-right
      color="white"
      :app="$route.name === 'BodyEdit' ? true : false"
    >
      <v-row justify="space-between" class="px-4" align="center">
        <div class="setDeviceView">
          <div :class="{'selectedViewType': editViewType === 'desktop'}" @click="handleChangeViewType('desktop')">
            <v-icon size="20" :color="editViewType === 'desktop' ? 'bt_color': 'bt_text'">fa-light fa-desktop</v-icon>
          </div>
          <div></div>
          <div :class="{'selectedViewType': editViewType === 'mobile'}" @click="handleChangeViewType('mobile')">
            <v-icon size="20" :color="editViewType === 'mobile' ? 'bt_color': 'bt_text'">fa-light fa-mobile-screen-button</v-icon>
          </div>
        </div>

        <div class="bt_text--text slug-page">
          <h3>{{ hotsite.nome }}</h3>

          <Select
            v-model="selectedVersion"
            :items="versionList"
            :width="$vuetify.breakpoint.mdAndUp ? '200px' : '40px'"
            :mobile="true"
            className="app-bar-custom-font-size"
            background-color="white"
            :useItemTemplate="true"
          >
            <template v-slot:item="{ item }">
              <v-list-item v-if="item.isCategory" disabled>
                <v-list-item-content>
                  <v-list-item-title>
                      <div style="font-size: 0.8rem; font-weight: bold; color: #192B46">{{ item.text }}</div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <div v-else style="font-size: 0.8rem; padding-left: 6px;">{{ item.text }}</div>
            </template>            
          </Select>

          <div :class="[
            'status-style', 
            {'status-published': checkStatus === 'Publicado'},
            {'status-draft': checkStatus === 'Rascunho'},
            {'status-': checkStatus === 'Rascunho'},
          ]">
          {{ checkStatus}}</div>
        </div>

        <div class="d-flex" style="gap: 8px">
          <Button 
            label="Visualizar" 
            textSize="0.80rem"
            color="lightBlue"
            textColor="bt_color"
            @click="handleOpenPage"          
          />   

          <Button 
            v-if="!publishedVersion"
            :disabled="loadingR || !haveChanges"
            label="Salvar" 
            textSize="0.80rem"
            @click="saveHotsite('R')"          
          />          

          <Button 
            :disabled="loadingP || (publishedVersion && !haveChanges)"
            :label="publishedVersion ? `Salvar e Publicar` : `Publicar`" 
            textSize="0.80rem"
            color="bt_green"
            @click="openDialogConfirm"          
          />          
        </div>
      </v-row>
    </v-app-bar>

    <v-dialog v-model="dialogConfirm" width="400" persistent>
      <dialog-confirm
        @close="closeDialogConfirm"
        :loading="loadingP"
        @confirm="saveHotsite('P')"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { changeNullForStringValue } from '../../helpers/recursive'
import DialogConfirm from "./dialogs/DialogConfirm";
import Select from '../_v2/ui/Select.vue'
import Button from '../_v2/ui/Button.vue'

export default {
  components: {
    DialogConfirm,
    Select,
    Button
  },
  data() {
    return {
      dialogConfig: false,
      dialogConfirm: false,
      published: false,
      loadingP: false,
      loadingR: false,
      haveChanges: false
    };
  },

  computed: {
    ...mapGetters(["hotsite", "hotsiteVersions", "hotsiteSelectedVersion", "infos", "infosCopy", "snackbar", "editViewType"]),
    publishedVersion() {
      if (
        this.hotsite.versao_especifica &&
        this.hotsite.versao_publicada &&
        this.hotsite.versao_especifica.codigo ===
          this.hotsite.versao_publicada.codigo
      )
        return true;
      else if (this.hotsite.versao_publicada && !this.hotsite.versao_especifica)
        return true;
      else if (this.published) return true;
      else return false;
    },

    checkStatus () {
      if (this.publishedVersion) return 'Publicado'
      else  return 'Rascunho'
    },

    versionList () {
      let versions = this.hotsiteVersions.map(version => ({value: version.codigo, text: `${this.hotsite.slug}-v-${version.codigo}`}))
      if (versions.length === 0) versions = [{value: this.hotsite.versao_especifica.codigo, text: `${this.hotsite.slug}-v-${this.hotsite.versao_especifica.codigo}`}]

      return [
        {isCategory: true, text: 'Versões disponíveis'},
        ...versions
      ]
    },

    selectedVersion: {
      get () { return this.hotsiteSelectedVersion },
      set (v) { 
        this.infos.sections.forEach((section) => { section.idLayout = 'default-style'})
        this.$store.commit('SET_HOTSITE_SELECTED_VERSION', v) 
      }
    }
  },

  methods: {
    openConfig() {
      this.$store.dispatch("setNav", { open: true, sectionId: "config" });
    },

    async saveHotsite(status) {
      if (status === "P") this.loadingP = true;
      if (status === "R") this.loadingR = true;
      await this.$store
        .dispatch("saveHotsite", {
          code: this.hotsite.codigo,
          code_organizer: this.hotsite.codigo_organizador,
          name: this.hotsite.nome,
          domain: this.hotsite.dominio,
          slug: this.hotsite.slug,
          code_version: this.hotsite.versao_especifica.codigo,
          code_hotsite: this.hotsite.versao_especifica.codigo_hotsite,
          status: status,
          config: this.infos,
          token: this.$route.params.token,
        })
        .then((response) => {
          if (status === "P" && response.status === 200) {
            this.dialogConfirm = false;
            this.published = true;
          } else if (status === "P" && response.status !== 200) this.loadingP = false;
          else if (status === "R" && response.status !== 200) this.loadingR = false;

          // save copy to compare
          if (response.status === 200) {
            const infosCopy = JSON.parse(JSON.stringify(this.infos))
            this.$store.commit("SET_INFOS_COPY", infosCopy)
            this.haveChanges = false   
          }     
        });
      if (status === "P") this.loadingP = false;
      if (status === "R") this.loadingR = false;
    },

    closeDialogConfirm() {
      this.dialogConfirm = false;
    },

    openDialogConfirm() {
      this.dialogConfirm = true;
    },

    handleOpenPage () {
      let url = window.location.href
      if (!url) return

      url = url.split('/edit')[0]
      window.open(url, '_blank')
    },

    handleChangeViewType(type) {
      if (type === 'mobile') this.$vuetify.breakpoint.mdAndUp = false
      else this.$vuetify.breakpoint.mdAndUp = true
      this.$store.dispatch('setEditViewType', type)
    },

    preventClose (event) {
      if (this.haveChanges) {
        event.preventDefault()
        event.returnValue = '' 
      }     
    }
  },

  watch: {
    infos: {
      deep: true,
      handler (currentInfos) {
        if (this.$route.name === 'BodyEdit') {
          const infos = changeNullForStringValue(JSON.parse(JSON.stringify(currentInfos)))
          const infosCopy = changeNullForStringValue(JSON.parse(JSON.stringify(this.infosCopy)))

          if (JSON.stringify(infos) === JSON.stringify(infosCopy)) {
            // console.log('Nenhuma alteração detectada...')
            this.haveChanges = false
            window.removeEventListener('beforeunload', this.preventClose)
          } else {
            // console.log('Alteração detectada...')
            window.addEventListener('beforeunload', this.preventClose)
            this.haveChanges = true
          }

        }
      }
    }
  }
};
</script>

<style>
.app-bar-custom-font-size {
  font-size: 0.80rem;
  font-weight: 400;
}
</style>

<style scoped>
h2 {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
}

.btnNormal {
  text-transform: none !important;
  height: 36px !important;
  border-radius: 56px !important;
  padding: 0px 20px !important;
  color: white !important;
}

.btnOutlined {
  margin: 0px;
  text-transform: none;
  background-color: transparent !important;
  border: 1px solid #0067AF !important;
  box-sizing: border-box !important;
  border-radius: 56px !important;
  height: 36px !important;
  padding: 0px 20px !important;
  color: #0067AF !important;
}

b {
  font-size: 0.85rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 18px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
}

.appbar /deep/ .v-toolbar__content{
  border-bottom: 1px solid rgba(102, 109, 128, 0.1) !important;
}

.slug-page {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 50px;
}

h3 {
  font-size: 0.9rem;
  font-weight: 700;
}

h4 {
  font-size: 0.85rem;
  font-weight: 400;
  padding-top: 1px
}

.status-style {
  border-radius: 4px;
  padding: 4px 8px;
  font-weight: 700;
  font-size: 0.9rem;
  margin-left: 4px
}

.status-published {
  background: #00A65A1F;
  color: #00A65A
}

.status-draft {
  background: #E3EEF9;
  color: #0067AF
}

.setDeviceView {
  display: flex;
  width: 95px;
  height: 38px;
  align-items: center;
}

.setDeviceView > div:nth-child(2) {
  height: 100%;
  width: 1px;
  background-color: #0067AF80;
}

.setDeviceView > div:nth-child(1), 
.setDeviceView > div:nth-child(3) {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 47px;
  border: 1px solid rgba(102, 109, 128, 0.1);
}

.setDeviceView > div:nth-child(1) {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border-right: 0;  
}

.setDeviceView > div:nth-child(3) {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-left: 0;
}

.setDeviceView > div:nth-child(1).selectedViewType,
.setDeviceView > div:nth-child(3).selectedViewType {
  background: #E1F2FEB2;
  opacity: 1;
  border-color: #0067AF80
}
</style>
